import dynamic from 'next/dynamic';
import { GetServerSidePropsContext } from 'next';
import PageLayout from '@/components/PageLayout';
import SEOlinksA from '@/components/SEOlinksA';
import seoconfig from '@/seoconfig/calculators/blade';
import { useGlobal } from '@/utils/useGlobal';
import BladeCalculatorPC from '@/components/calculators/blade';
import BladeCalculatorH5 from '@/componentsH5/calculators/blade';

export default function BladeCalculatorPage({ SEO }: any) {
    const { useLang, useRouter, useEffect, isMobile } = useGlobal();
    const { t } = useLang('bladecalculator');
    const router = useRouter();
    const { locale } = router;
    const PageCom = isMobile ? BladeCalculatorH5 : BladeCalculatorPC;
    const GtmPageLoad = dynamic(() => import('@/components/GtmPageLoad'), { ssr: false });

    useEffect(() => {
        if (!['uk', 'eu', 'de', 'fr', 'it', 'es', 'au'].includes(locale)) {
            router.replace('/404');
        }
    }, [locale]);

    return (
        <PageLayout theme="black">
            <SEO title={t('title')} desc={t('desc')} />
            <SEOlinksA locale={locale} list={seoconfig.include} pathname={seoconfig.url} />
            <GtmPageLoad />
            <PageCom />
        </PageLayout>
    );
}

export async function getServerSideProps({ locale, query }: GetServerSidePropsContext) {
    // us ca 下线重定向到首页 2025/06/12
    if (['us', 'ca'].includes(locale as string)) {
        return {
            redirect: {
                destination: `/${locale}`,
                permanent: true,
            },
        };
    }

    return {
        props: {},
    };
}
